// src/sectors/pilates/dashboard/api/dashboardApi.js
import { http } from 'shared/api/http';

function toQuery(params = {}) {
  const p = new URLSearchParams();

  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;

    // LocalDate gelirse "2026-01-22" stringify olur zaten
    // number/string ok
    p.set(k, String(v));
  });

  const qs = p.toString();
  return qs ? `?${qs}` : '';
}

export const dashboardApi = {
  overview(params = {}) {
    const qs = toQuery(params);

    console.group('🟣 [dashboardApi.overview] GET /dashboard/overview');
    console.log('params:', params);
    console.log('query:', qs);
    console.groupEnd();

    return http(`/api/v1/pilates/dashboard/overview${qs}`, { method: 'GET' }).then((r) => {
      console.log('🟣 [dashboardApi.overview] response:', r);
      return r || null;
    });
  },
};
